// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"_54P89G","mainContent":"yAbeMS","extraInfoBlock":"dsTjur","descriptionBlock":"_4aO6E2","sidebar":"GuYYbg","breadcrumbs":"_3fGlpy","rubic":"yu6wlf"};